<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18">
		<g id="" data-name="Gruppe 14978" transform="translate(-332 -46)">
			<line id="" data-name="Linie 6" x2="20" transform="translate(333 47)" fill="none" :stroke="color" stroke-linecap="round" stroke-width="2" />
			<line id="" data-name="Linie 7" x2="20" transform="translate(333 55)" fill="none" :stroke="color" stroke-linecap="round" stroke-width="2" />
			<line id="" data-name="Linie 8" x2="20" transform="translate(333 63)" fill="none" :stroke="color" stroke-linecap="round" stroke-width="2" />
		</g>
	</svg>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
export default defineComponent({
	name: 'MenuIcon',
	data() {
		return {};
	},
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
});
</script>
